import { useSelector } from "react-redux"

/**
 * 
 * @param {String} subHeading heading label will be shown if present - Taken from Redux store
 * @param {ReactNode} additionalSubHdView Any ReactNode element - eg. Buttons  - Taken from Redux store
 * @returns 
 */

const UMCSubHeader = () => {

    const subHeading = useSelector(state => state.common.subHeading)
    const additionalSubHdView = useSelector(state => state.common.additionalSubHdView)

    return <div className="sub-header">
        {(subHeading) ?
            <div className="heading">{subHeading}</div> :
            <></>
        }
        {additionalSubHdView ? <div className="shd-extra-content">{additionalSubHdView}</div> : <></>}

    </div>
}

export default UMCSubHeader